import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import PDF from "../../../../assets/images/Pdf.png";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Markup } from "interweave";
import noImage from "../../../../assets/images/settings/no-image.png";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import cup from "../../../../assets/images/page 1.png";
import "./PromoInstructionSendInfo.css";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../Reuseable/LoaderPost";

const PromoInstructionSendInfo = () => {
  const { imageCdnUrl,videoCdnUrl,serverUrl } = useContext(serverInfo);

  const [isEditShow, setIsEditShow] = useState(false);
  let { id } = useParams();
  const [audition, setAudition] = useState({});
  const [auditionInstructionSendInfo, setAuditionInstructionSendInfo] =
    useState({});
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();

  const getAuditionByPromoInstructionSendInfo = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/superstar/audition/by-promo-instruction-pending/${id}`)
        .then((res) => {
          if (res.data.status === 200) {
            setAudition(res.data.audition);
            setConvertedContent(
              res.data.auditionPromoInstructionSendInfo.instruction
            );
            setAuditionInstructionSendInfo(
              res.data.auditionPromoInstructionSendInfo
            );
            setVideoFile(
              videoCdnUrl + res.data?.auditionPromoInstructionSendInfo?.video
            );
            setFile(
              imageCdnUrl + res.data?.auditionPromoInstructionSendInfo?.image
            );
          }
        });
    });
    setLoading(false);
  };
  useEffect(async () => {
    getAuditionByPromoInstructionSendInfo();
  }, [id]);

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const updatePromoInstructionInfo = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", audition.id);
    fData.append(
      "audition_promo_instruction_send_info_id",
      auditionInstructionSendInfo.id
    );
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/superstar/audition/by-promo-instruction-update`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.push(
              `/superstar/audition/promo-instruction-send-info/${auditionInstructionSendInfo.id}`
            );
            getAuditionByPromoInstructionSendInfo();
            setIsEditShow(false);
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {isEditShow ? (
            <>
              <div className="liveMeetupBorder">
                <div className="d-flex px-4">
                  <div className="faTrophy p-2">
                    <img src={cup} alt="" className="mt-1" width="30px" />{" "}
                    <span className="text-waning p-2 fw-bolder">
                      Promo Instruction Info send
                    </span>
                  </div>
                </div>
                <div className="my-2">
                  <form
                    onSubmit={updatePromoInstructionInfo}
                    id="input_form"
                    encType="multipart/form-data"
                  >
                    <div className="row ms-5">
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-2 col-form-label text-light "
                        >
                          Post Title
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control Frombtns"
                            value={audition.title}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="inputPassword"
                          className="col-sm-2 col-form-label text-light "
                        >
                          Instruction
                        </label>
                        <div className="col-sm-8">
                          <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent}
                            onChange={(audition, editor) => {
                              const data = editor.getData();
                              setConvertedContent(data);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.instruction}
                          </span>
                        </div>
                      </div>
                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Upload Video
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row my-4">
                            <div className="col-md-10">
                              {videoFile ? (
                                <>
                                  <ReactPlayer
                                    url={videoFile}
                                    // width="100%"
                                    controls={true}
                                    height="35vh"
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <input
                                type="file"
                                name="file"
                                id="setFile"
                                className="inputfile w-25"
                                accept="video/mp4"
                                onChange={(e) =>
                                  handleVideoChange(e.target.files)
                                }
                              />

                              <label for="setFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Video
                              </label>
                              <span className="text-danger">
                                {errorList.video}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Upload Banner
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row my-4">
                            {file ? (
                              <img
                                src={file}
                                alt="..."
                                className="demo-preview-image img-fluid"
                              />
                            ) : (
                              ""
                            )}
                            <div className="col-md-10">
                              <input
                                type="file"
                                name="imageFile"
                                id="imageFile"
                                className="inputfile w-25"
                                accept="image/jpg,image/jpeg, image/png"
                                onChange={(e) =>
                                  handleImageChange(e.target.files)
                                }
                              />

                              <label for="imageFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Image
                              </label>
                              <span className="text-danger">
                                {errorList.image}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mt-3">
                        <label
                          for="staticEmail"
                          className="col-sm-3 col-form-label text-light "
                        >
                          Instruction pdf for the post
                        </label>

                        <div className="col-sm-7 mb-2">
                          <div className="row d-flex justify-content-end my-4">
                            <div className="col-md-2 text-white"></div>
                            <div className="col-md-3 inputeParent">
                              <input
                                type="file"
                                name="pdfFile"
                                id="pdfFile"
                                accept=".pdf"
                                className="inputfile w-25"
                                onChange={(e) =>
                                  handlePdfChange(e.target.files)
                                }
                              />
                              <label for="pdfFile">
                                <i className="fa-solid fa-file-pdf"></i> 1 MB
                                Maximum
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-end my-4">
                        <div className="col-md-3 text-left">
                          <button
                            className="btn btn-warning px-4 fw-bold"
                            type="submit"
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row mx-1 mt-4 mb-5">
                <div className="card card-bg Send-info  bhxd border-warning  ">
                  <h5 className="text-warning  fw-bold mt-3 mb-2">
                    Audition Post Description
                  </h5>
                  <p className="card-text text-light">
                    <Markup content={auditionInstructionSendInfo.description} />
                  </p>

                  <h5 className="text-warning  fw-bold mt-3 mb-2">
                    Audition Post Thumnil Demo
                  </h5>

                  <img
                    src={
                      auditionInstructionSendInfo.image != null
                        ? imageCdnUrl + auditionInstructionSendInfo.image
                        : noImage
                    }
                    alt=""
                    className="img-fluid ImGHx"
                  />

                  <h5 className="text-warning  fw-bold mt-4 mb-2">
                    Audition Post Video Instruction
                  </h5>

                  <div className="VideoXSA">
                    <ReactPlayer
                      url={
                        auditionInstructionSendInfo?.video
                          ? videoCdnUrl + auditionInstructionSendInfo.video
                          : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                      }
                      className="jxk"
                      width="100%"
                    />
                  </div>

                  <div className="text-light justify-content-between d-flex my-3 bg-gray p-3">
                    <div className="text-warning fw-bold pt-3">
                      <h4>PDF files From Jeams</h4>
                    </div>
                    <div className="text-warning fw-bold ">
                      {auditionInstructionSendInfo?.document != null ? (
                        <>
                          <a
                            href={
                              serverUrl + auditionInstructionSendInfo.document
                            }
                            download="document.pdf"
                          >
                            <center>
                              <img src={PDF} alt="" width="40" />
                              <br />
                              <b>Download</b>
                            </center>
                          </a>
                        </>
                      ) : (
                        <>
                          <center>
                            <img src={PDF} alt="" width="40" />
                            <br />
                            <b>No Document Found</b>
                          </center>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex mt-4 mb-3 justify-content-center">
                    <button
                      onClick={() => setIsEditShow(true)}
                      className="btn bg-info text-light px-3  py-2  fw-bold"
                    >
                      Edit <i className="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default PromoInstructionSendInfo;
